module.exports = __webpack_public_path__ + "static/img/02.e5f86e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/110719/02.png
// module id = UdEJ
// module chunks = 0